export const SMSConnectionID = 'CONNECTION-sms';

export const VoiceConnectionID = 'CONNECTION-voice';

export const knowledgeAppType = 'AIAssistant';

export const DEFAULT_CHAT_RECEPTIONIST_AVATAR_SVG_ICON = 'ai-chat-receptionist';
export const DEFAULT_AVATAR_SVG_ICON = 'galaxy-ai-icon-with-background';

export const AI_ASSISTANTS = 'ai_assistant_feature';
export const CUSTOM_ASSISTANTS = 'custom_ai_assistants';
export const ASSISTANT_GOALS = 'assistant_goals';
export const AI_MEETING_BOOKING = 'ai_meeting_booking';
export const NEW_CUSTOM_AI_GOALS = 'custom_ai_goals';

export const WEBCHAT_WIDGET_CONNECTION_TYPE = 'WebchatWidget';

export const ASSISTANT_ID_CHAT_RECEPTIONIST = 'ASSISTANT-chat-receptionist';
export const ASSISTANT_ID_VOICE_RECEPTIONIST = 'ASSISTANT-voice-receptionist';
export const ASSISTANT_ID_CONTENT_CREATOR = 'ASSISTANT-content-creator';
export const ASSISTANT_ID_REVIEW_MANAGER = 'ASSISTANT-review-manager';
export const ASSISTANT_ID_SEO_ANALYST = 'ASSISTANT-seo-analyst';
export const ASSISTANT_ID_SALES_COACH = 'ASSISTANT-sales-coach';
export const disabled_card_colour = '#e0e0e0';
export const DEFAULT_CONNECTION_PREFIX = 'default-';

export const WEBCHAT_ICON = 'https://vstatic-prod.apigateway.co/business-center-client.9223372035109856043.prod/assets/webchat-icon.svg';
export const SMS_ICON = 'https://vstatic-prod.apigateway.co/business-center-client.9223372035109856043.prod/assets/phone.svg';
export const VOICE_ICON = 'https://vstatic-prod.apigateway.co/business-center-client.9223372035109856043.prod/assets/old-phone.svg';
